// extracted by mini-css-extract-plugin
export default {"mollieActivation":"ICSL5f2vRLEGPmYxzPN2wA=="};